module.exports = __webpack_public_path__ + "media/images/home-veganbooty-fbb6609026370b0f7ba42c0458c18135.jpg";